<div class="d-flex flex-wrap pt-3">
  <span *ngFor="let perk of perks.items" class="col-3 mb-3 text-center">
    {{ perk }}
  </span>

  <span *ngIf="perks.items.length === 0" class="text-muted">
    Il n'y a actuellement aucun plus pour ce bien.
  </span>
</div>
